import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';

import { withScroll } from '../requestConsultationButton/withScroll';

import getRandomId from '../../utils/randomId';

import SVG from '../../assets/images/example_image.jpg';
import {gsap} from 'gsap';

const Wrapper = styled.div`
  margin-top: -70px;
  @media (max-width: 1200px) {
    margin-top: -41px;
  }
  @media (max-width: 600px) {
    margin-top: 0;
  }
  width: 100%;
  overflow: hidden;
  max-width: 600px;
`;

const Img = styled.img`
  width: 150%;
`;

const Image = ({ alt = 'Image', }) => {
  return (
    <Wrapper data-scroll data-scroll-speed="-1" data-scroll-offset="-100px">
      <div data-scroll data-scroll-speed="-1">
        <Img
          data-scroll
          data-scroll-offset="-200%"
          data-scroll-position="top"
          data-scroll-direction="horizontal"
          data-scroll-speed="1"
          src={SVG}
          alt={alt}
        />
      </div>
    </Wrapper>
  );
};

export default Image;
